// extracted by mini-css-extract-plugin
module.exports = {"menuList":"MenuList_menuList__Csm5a","panel":"MenuList_panel__xyYD9"};